export enum TopLevelModuleName {
  'public' = 'public',
  'auth' = 'auth',
  'client' = 'client',
  'admin' = 'admin',
}
